<template>
  <div class="home">
  </div>
</template>

<script>
export default {
  name: 'home',
  beforeRouteEnter () {
    window.location = 'https://pundix.com'
  }
}
</script>
